import { AxiosResponse } from 'axios';
import Archivable, { ArchivedUpdatedEvent } from './shared/archivable';
import Entity from './shared/entity';
import { Event } from './shared/eventstore-client/EventstoreClient';
import { ServiceClientWithEventstore } from './shared/service-client/ServiceClientWithEventstore';

export interface MessageResponse {
  message: string;
}

export interface TPLOrder extends TPLOrderProperties, Entity, Archivable {}

export interface TPLOrderProperties {
  orderNumber: string;
  twinId: string;
}

export interface GetTPLOrdersResponse {
  tplOrders: TPLOrder[];
  continuationToken?: string;
}

export interface GetTPLOrdersRequest {
  limit?: number;
  continuationToken?: string;
  twinId?: string;
}

export type CreateTPLOrder = TPLOrderProperties;
export type UpdateTPLOrder = Partial<TPLOrderProperties>;

export type PERMISSIONS =
  | typeof GET_ALL
  | typeof CREATE
  | typeof UPDATE
  | typeof GET_EVENTS_ANY
  | typeof GET_EVENTS_CREATED
  | typeof GET_EVENTS_UPDATED
  | typeof SET_ARCHIVED;

export const CREATE = 'TPL_ORDER:CREATE';
export const UPDATE = 'TPL_ORDER:UPDATE';
export const GET_ALL = 'TPL_ORDER:GET_ALL';
export const SET_ARCHIVED = 'TPL_ORDER:SET_ARCHIVED';
export const GET_EVENTS_ANY = 'TPL_ORDER:GET_EVENTS:ANY';
export const GET_EVENTS_CREATED = 'TPL_ORDER:GET_EVENTS:CREATED';
export const GET_EVENTS_UPDATED = 'TPL_ORDER:GET_EVENTS:UPDATED';
export const GET_EVENTS_ARCHIVED_UPDATED = 'TPL_ORDER:GET_EVENTS:ARCHIVED_UPDATED';

export const TPL_ORDER_PERMISSION_NAMES = {
  CREATE,
  UPDATE,
  GET_ALL,
  SET_ARCHIVED,
  GET_EVENTS_ANY,
  GET_EVENTS_CREATED,
  GET_EVENTS_UPDATED,
  GET_EVENTS_ARCHIVED_UPDATED,
};

export interface CreatedEvent extends Event {
  type: 'CREATED';
  data: TPLOrder;
}

export interface UpdatedEvent extends Event {
  type: 'UPDATED';
  data: TPLOrder;
}

export type TPLOrderEvents = CreatedEvent | UpdatedEvent | ArchivedUpdatedEvent;

export interface GetAllTPLOrdersRequest {
  limit?: number;
  continuationToken?: string;
  twinId?: string;
  allowArchived?: boolean;
}

export interface GetTPLOrdersResponse {
  tplOrders: TPLOrder[];
  continuationToken?: string;
}

export class TPLOrderClient extends ServiceClientWithEventstore<TPLOrderEvents> {
  public async getAll(input: GetAllTPLOrdersRequest = {}): Promise<AxiosResponse<GetTPLOrdersResponse>> {
    return await this.httpClient.get('/', {
      params: input,
      ...this.requestConfig,
    });
  }

  public async create(t: CreateTPLOrder): Promise<AxiosResponse<TPLOrder>> {
    return await this.httpClient.post('/', t, this.requestConfig);
  }

  public async update(id: string, t: UpdateTPLOrder): Promise<AxiosResponse<TPLOrder>> {
    return await this.httpClient.patch(`/${id}`, t, this.requestConfig);
  }

  public async setArchived(id: string, archived: boolean): Promise<AxiosResponse<TPLOrder>> {
    return await this.httpClient.put(`/${id}/archived`, { archived }, this.requestConfig);
  }
}
